(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-ftl-accessories]').forEach(panel => {
      if (panel.dataset.ftlReady) return;
      panel.dataset.ftlReady = 'true';
      const viewport = panel.querySelector('[data-ftl-accessories-viewport]');
      const footer = panel.querySelector('[data-ftl-accessories-footer]');
      const toggle = panel.querySelector('[data-ftl-accessories-toggle]');
      const label = panel.querySelector('[data-ftl-accessories-label]');
      const selection = panel.querySelector('[data-ftl-accessories-selection]');
      const count = panel.querySelector('[data-ftl-accessories-count]');
      if (!viewport || !footer || !toggle || !label) return;
      const setExpanded = expanded => {
        panel.classList.toggle('is-collapsed', !expanded);
        viewport.inert = !expanded;
        toggle.setAttribute('aria-expanded', String(expanded));
        label.textContent = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
      };
      const updateCount = () => {
        const selected = panel.querySelectorAll('[data-accessory-check]:checked').length;
        if (selection && count) { selection.hidden = selected === 0; count.textContent = selected; }
      };
      footer.hidden = false;
      setExpanded(false);
      updateCount();
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        const top = panel.getBoundingClientRect().top;
        setExpanded(expanded);
        if (!expanded && top < 0) panel.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
      panel.addEventListener('change', updateCount);
    });
    root.querySelectorAll('[data-ftl-bundle]').forEach(form => {
      if (form.dataset.ftlReady) return;
      form.dataset.ftlReady = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (button.disabled) return;
        const label = button.textContent;
        const status = form.querySelector('[data-ftl-bundle-status]');
        button.disabled = true;
        button.textContent = form.dataset.adding;
        status.textContent = '';
        try {
          const response = await fetch(form.action + '.js', {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || form.dataset.error);
          await window.FTLGift?.sync();
          window.location.assign(form.dataset.cartUrl);
        } catch (error) {
          status.textContent = error.message || form.dataset.error;
          button.disabled = false;
          button.textContent = label;
        }
      });
    });
    root.querySelectorAll('[data-ftl-mobile-purchase]').forEach(bar => {
      if (bar.dataset.ftlReady) return;
      bar.dataset.ftlReady = 'true';
      const link = bar.querySelector('[data-ftl-purchase-link]');
      const form = document.getElementById(link.hash.slice(1));
      const button = form?.querySelector('[data-add-button]');
      if (!button || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(entries => {
        bar.hidden = entries[0].isIntersecting;
      }, {threshold: 0.1}).observe(button);
      link.addEventListener('click', event => {
        event.preventDefault();
        form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
        form.querySelector('input[type="radio"]:checked, [data-add-button]')?.focus({preventScroll:true});
      });
      document.addEventListener('variant:change', event => {
        if (!event.detail?.variant) return;
        const displayed = form.closest('.dji-product')?.querySelector('[data-main-price]');
        if (displayed) bar.querySelector('[data-ftl-mobile-price]').textContent = displayed.textContent;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
